import { request } from "../../api/api"
import { downloadFile } from "../../utils/utils"

export const activeUserGraph = ()=>{
    return request.get("/active-user-graph/")
}
export const jobApplicationOverview = (params)=>{
    return request.get("/job-application-overview/", { params })
}
export const topJobCategories = ()=>{
    return request.get("/top-job-categories/")
}

export const analyticsExportReport = (params) => {
    let url = '/analytics-export-report/';
    // If both start_date and end_date exist, append them as query parameters
    if (params.start_date && params.end_date) {
        const query = new URLSearchParams({
            start_date: params.start_date,
            end_date: params.end_date,
        }).toString();
        url += `?${query}`;
    }

    return downloadFile(url, "GET");
};
